// extracted by mini-css-extract-plugin
export var clickable = "PickSlipUnauthorizedAlerts-module--clickable--fc36c";